import { render } from "./ClienteInformacoes.vue?vue&type=template&id=2c4615e8&scoped=true"
import script from "./ClienteInformacoes.vue?vue&type=script&lang=js"
export * from "./ClienteInformacoes.vue?vue&type=script&lang=js"

import "./ClienteInformacoes.vue?vue&type=style&index=0&id=2c4615e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4615e8"]])

export default __exports__